
export interface TextMeasurementProvider {
	getWidth: (text: string, fontSize: number, fontFace?: string) => number
}

export const measureText = (function():TextMeasurementProvider {
	const canvas = document.createElement("canvas");
	const ctx: CanvasRenderingContext2D|any = canvas.getContext("2d");

	function getWidth(text: string, fontSize:number, fontFace: string) {
		ctx.font = `${fontSize}px ${fontFace ?? 'sans-serif'}`;
		return ctx.measureText(text).width;
	}

	return {
		getWidth
	};
})();
